import axios from 'axios';
import { toast } from 'react-toastify';

export const axiosCustom = axios.create({
  baseURL: process.env.REACT_APP_SERVER_API,
});

axiosCustom.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// Add a request interceptor
axiosCustom.interceptors.response.use(
  (response) => {
    const message = response?.data?.message;
    if (response.status === 200 && message) {
      toast.success(message);
    }
    return response;
  }, // Directly return successful responses.
  async (error) => {
    const message = error.response?.data?.message;
    // console.log(error);

    if (error.response.status === 401 && !window.location.pathname?.includes('/order/') && window.location.pathname !== '/') {
      const originalRequest = error.config;

      originalRequest._retry = true;
      window.location.href = '/';
    }
    if (error.response.status === 400) {
      toast.error(message);
    }

    return Promise.reject(error);
  },
);
